import React, { useState, useEffect } from "react";
import Loading from "../Components/Loading";
import * as api from "../api/api";
import FormRowData from "../Components/Agent/FormRowData";
import DropdownSearch from "../Components/DropdownSearch";
import DropdownSearchSingle from "../Components/DropdownSearchSingle";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import generateReport from "../generateReport";
import * as XLSX from "xlsx";
import strings from "../Components/Localization/strings";
import { useLanguage } from "../Components/Localization/LanguageContext";

import { Button } from "@mui/material";
import { Button as BootstrapButton } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";

import { useUserCache } from "../Components/UserCacheProvider";

import Select from "react-select";

function AdminIntradayView(props) {
  const [isLoading, setLoading] = useState(false);
  const [historyForms, setHistoryForms] = useState([]);
  const { language } = useLanguage();
  const pageTitle = "AdminIntradayView";
  const { getUser, setUser, setAllUsers } = useUserCache();

  const activityTypes = strings[pageTitle][language].activityTypes;

  const [allFormsInAllPages, setAllFormsInAllPages] = useState([]);

  let exportDataModel = {
    "Activity Id": 0,
    Created: "dateString",
    "User Id": "sampleUserId",
    "Employee Name": "Name",
    "ACD-Login": "??",
    Team: "Sample Team",
    Service: "Sample Service",
    Form: "Form name",
    "Activity Type": "Activity name",
    Billable: "T/F?",
    "Start Time": "date",
    "End time": "date",
    Duration: "total dur",
    "Pause Duration": "paused",
    "Field Group": "??",
    "Field Name": "name",
    "Captured Value": "??",
    Unit: "??",
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const navigate = useNavigate();

  function getFormattedDate(date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  function getFormattedDateWithHours(date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hours = today.getHours().toString().padStart(2, "0");
    const minutes = today.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}_${hours}-${minutes}`;
  }

  function timestampToHHMMSS(timestamp) {
    const dateObject = new Date(timestamp);

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return formattedTime;
  }

  const startDateString = getFormattedDate(new Date());
  const endDateString = getFormattedDate(
    new Date(Date.now() + 24 * 60 * 60 * 1000)
  );

  const [filter, setFilter] = useState({
    startDate: startDateString,
    endDate: endDateString,
    page: currentPage,
    size: pageSize,
    formIds: [],
    serviceIds: [],
    teamIds: [],
    userIds: [],
    processTypeIds: [],
    isBillable: null,
    isFinalized: true,
  });
  const [services, setServices] = useState([]);
  const [agentInfo, setAgentInfo] = useState();
  const [forms, setForms] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const billableTypes = strings[pageTitle][language].billableTypes;
  const finalizedTypes = strings[pageTitle][language].finalizedTypes;

  const initialiseFilterItems = () => {
    setLoading(true);
    api.getAllServices().then((response) => {
      setServices(response.data.object);
    });
    api.getAllForms().then((response) => {
      setForms(response.data.object);
    });
    api.getAllUsers().then((response) => {
      setUsers(response.data.object);
      setAllUsers(response.data.object);
    });
    api.getAllTeams().then((response) => {
      setTeams(response.data.object);
    });
  };

  function secondsToHMS(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = Math.floor(seconds % 60);

    // Add leading zeros if needed
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    remainingSeconds =
      remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

    return hours + ":" + minutes + ":" + remainingSeconds;
  }

  const [exportTableGPI, setExportTableGPI] = useState([]);
  const [exportTableForms, setExportTableForms] = useState([]);
  let [allProcessFieldsInfo, setAllProcessFieldsInfo] = useState();

  const exportActivitiesToExcel = (filename) => {
    const table = document.getElementById("myTable");
    const ws = XLSX.utils.table_to_sheet(table);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* generate XLSX file and save to file */
    XLSX.writeFile(wb, filename + ".xlsx");
    //table.hidden = true;
  };

  const handleFetchFilteredProcesses = (values, page = 1) => {
    setLoading(true);

    let searchParts = values;
    try {
      searchParts = {
        [values.split(":")[0]]: values.split(":")[1].split(","),
      };
      if (searchParts.hasOwnProperty("processTypeIds")) {
        let idValues = [];
        searchParts.processTypeIds.forEach((value) => {
          function findIdByName(name) {
            const activity = activityTypes.find(
              (activity) => activity.name === name
            );
            return activity ? activity.id : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.processTypeIds = null;
        } else {
          searchParts.processTypeIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("serviceIds")) {
        let idValues = [];
        console.log(searchParts.serviceIds);
        searchParts.serviceIds.forEach((value) => {
          function findIdByName(name) {
            const activity = services.find((service) => service.name === name);
            return activity ? activity.serviceId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.serviceIds = null;
        } else {
          searchParts.serviceIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("formIds")) {
        let idValues = [];
        searchParts.formIds.forEach((value) => {
          function findIdByName(name) {
            const activity = forms.find((form) => form.name === name);
            return activity ? activity.formId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.formIds = null;
        } else {
          searchParts.formIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("userIds")) {
        let idValues = [];
        searchParts.userIds.forEach((value) => {
          function findIdByName(username) {
            const user = users.find((user) => user.username === username);
            return user ? user.userId : -1;
          }
          idValues.push(findIdByName(value));
        });

        if (idValues[0] === -1 && idValues.length === 1) {
          console.log("hena");
          searchParts.userIds = [];
        } else {
          searchParts.userIds = idValues;
        }
        console.log(searchParts);
      } else if (searchParts.hasOwnProperty("teamIds")) {
        let idValues = [];
        searchParts.teamIds.forEach((value) => {
          function findIdByName(name) {
            const activity = teams.find((team) => team.name === name);
            return activity ? activity.teamId : null;
          }
          idValues.push(findIdByName(value));
        });
        searchParts.teamIds = idValues;
      } else if (searchParts.hasOwnProperty("isBillable")) {
        if (searchParts["isBillable"] == "true") {
          searchParts["isBillable"] = true;
        } else if (searchParts["isBillable"] == "false") {
          searchParts["isBillable"] = false;
        } else {
          searchParts["isBillable"] = null;
        }
      } else if (searchParts.hasOwnProperty("isFinalized")) {
        if (searchParts["isFinalized"] == "true") {
          searchParts["isFinalized"] = true;
        } else if (searchParts["isFinalized"] == "false") {
          searchParts["isFinalized"] = false;
        } else {
          searchParts["isFinalized"] = null;
        }
      }
      console.log(searchParts);
    } catch (e) {
      console.log(e);
    }

    const updatedFilter = { ...filter, ...searchParts, page: page };
    setCurrentPage(page);
    setFilter(updatedFilter);

    api.getAllFilteredReports(updatedFilter).then((response) => {
      console.log(response.data.object);

      setNumberOfPages(response.data.object.totalPages);

      // code to get all processes in the excel report
      let pages = 0;
      pages = response.data.object.totalPages;
      //console.error(response.data.object.totalPages);

      setAllFormsInAllPages([]);

      let inversePages = 1;

      while (pages > 0) {
        //console.error(pages, ", I am now requesting page: ", inversePages);
        let newFormsArray = [];
        let reportFilter = { ...updatedFilter, page: inversePages };
        api.getAllFilteredReports(reportFilter).then((response) => {
          //console.error(response.data.object.history);

          response.data.object.history.forEach((newForm) => {
            if (
              !newFormsArray.some((obj) => obj.processId == newForm.processId)
            ) {
              //console.error("I ADDED A NEW ONE TO: ", allFormsInAllPages);

              setAllFormsInAllPages((prevForms) => [...prevForms, newForm]);
            }
          });
        });

        pages--;
        inversePages++;
      }

      console.log(allFormsInAllPages);

      console.log("the filter used is: ", updatedFilter);
      const { history } = response.data.object;
      console.log("history: ", history);

      const processHistoryData = async () => {
        const getUserPromises = history.map(async (process) => {
          let sumDurations = 0;
          if (process.allProcessTimes && process.allProcessTimes.length > 0) {
            process.allProcessTimes.forEach((time) => {
              sumDurations += time.duration;
            });
          }
          process.duration = sumDurations;

          if (process.userId !== null) {
            const user = await getUser(process.userId);
            process.agentName = user.name;
            process.acdLogin = user.username;
          }
          return process;
        });

        const updatedHistory = await Promise.all(getUserPromises);

        if (history.length === 0) {
          setHistoryForms([]);
        } else {
          setHistoryForms(
            updatedHistory.filter((process) => process.isFinalized)
          );
        }
      };

      processHistoryData();

      if (
        response.data.object.currentPage == 1 &&
        response.data.object.size == 0
      ) {
        setCurrentPage(0);
      }
      setNumberOfItems(response.data.object.totalSize);
    });

    setLoading(false);
  };

  const prepareReportData = async () => {
    console.log("Preparing report data...");
    setLoading(true);
    setAllProcessFieldsInfo([]);

    let formsData = [];

    //console.error(allFormsInAllPages);

    // Use a Set to keep track of unique processIds
    const uniqueProcessIds = new Set();

    // Filter the array to remove duplicates based on processId
    const uniqueArray = allFormsInAllPages.filter((obj) => {
      if (!uniqueProcessIds.has(obj.processId)) {
        // Add the processId to the set to mark it as seen
        uniqueProcessIds.add(obj.processId);
        return true;
      }
      return false;
    });

    //console.error(uniqueArray);

    uniqueArray.forEach((form) => {
      let sumDurations = 0;
      form.allProcessTimes.forEach((time) => {
        sumDurations += time.duration;
      });

      sumDurations = secondsToHMS(sumDurations);

      if (form.userId === null) {
        return "null agentId";
      }
      try {
        // get user from "users" state instead of calling per user
        let user = users.find((user) => user.userId === form.userId);
        if (user) {
          form.agentName = user.name;
          form.acdLogin = user.username;
        } else {
          form.agentName = "Unknown User";
          form.acdLogin = "Unknown User";
        }

        /*api.getUserById(form.userId).then((response) => {
          //console.log(response);
          let name = response.data.object.name
            ? response.data.object.name
            : null;
          form.agentName = name;
          form.acdLogin = response.data.object.username;
          //console.log(form);
        });*/
      } catch (e) {}

      let formData = { ...exportDataModel };
      formData["Activity Id"] = form.processId;
      formData["Created"] = form.created;
      formData["User Id"] = form.userId;

      formData["Employee Name"] = form.agentName; //TODO: Find a way to map this agentId to a name
      formData["ACD-Login"] = form.acdLogin;
      let team = teams.find((team) => team.teamId === form.teamId);
      //console.error(team);
      formData["Team"] = team.name;
      formData["Service"] = form.service?.name;
      formData["Form"] = form.form;
      formData["Activity Type"] = form.processType.name;
      formData["Billable"] = form.isBillable ? "Yes" : "No";
      formData["Start Time"] = form.allProcessTimes[0].startTime;
      formData["End time"] =
        form.allProcessTimes[form.allProcessTimes.length - 1].endTime;
      formData["Duration"] = sumDurations;
      formData["Pause Duration"] = "TO BE DECIDED";
      formData["Field Group"] = "-";
      formData["Field Name"] = "-";
      formData["Captured Value"] = "-";
      formData["Unit"] = "-";
      formData.allProcessDetails = form.allProcessDetails;
      formsData.push(formData);
    });

    setExportTableGPI(formsData);

    // api call to get all the forms
    let allForms = [];
    let formsObject = [];

    allForms = forms;
    let fieldCount = 0;
    allForms.forEach((form) => {
      let fields = [];
      form.sections.forEach((section) => {
        section.sectionFields.forEach((field) => {
          fieldCount++;
          fields.push({
            [field.sectionFieldId]: [field.field.name],
          });
        });
      });
      formsObject.push({ [form.name]: fields });
    });
    setExportTableForms(formsObject);

    /*
    api.getAllForms().then((response) => {
      allForms = response.data.object;
      let fieldCount = 0;
      allForms.forEach((form) => {
        let fields = [];
        form.sections.forEach((section) => {
          section.sectionFields.forEach((field) => {
            fieldCount++;
            fields.push({
              [field.sectionFieldId]: [field.field.name],
            });
          });
        });
        formsObject.push({ [form.name]: fields });
      });
      setExportTableForms(formsObject);
    });*/

    let allProcessesInfo = [];

    exportTableGPI.forEach((process) => {
      let rowArr = [];

      if (process.allProcessDetails.length === 0) {
        let tableSize = 0;
        exportTableForms.forEach((form) => {
          let extracted = Object.values(form)[0];
          extracted = extracted.map((obj) => Object.keys(obj)[0]);

          if (extracted.length === 0) {
            extracted = [-1];
          }
          tableSize += extracted.length;
        });
        rowArr = Array(tableSize).fill(" ");
      } else {
        process.allProcessDetails.sort(
          (a, b) => a.sectionFieldId - b.sectionFieldId
        );
        process.allProcessDetails.forEach((detail) => {
          let offset = 0;

          exportTableForms.forEach((form, formIndex) => {
            let extracted = Object.values(form)[0];
            extracted = extracted.map((obj) => Object.keys(obj)[0]);

            if (extracted.length === 0) {
              extracted = [-1];
            }

            if (extracted.length === 0) {
              rowArr.splice(offset, 0, " ");
              offset++;
            } else {
              try {
                extracted.forEach((extract, fieldIndex) => {
                  if (extract == detail.sectionFieldId) {
                    rowArr[offset] = detail.value;
                  } else {
                    if (rowArr[offset] === undefined) {
                      rowArr[offset] = " ";
                    }
                  }
                  offset++;
                });
              } catch (e) {}
            }
          });
        });
      }
      allProcessesInfo.push(rowArr);
    });

    setAllProcessFieldsInfo(allProcessesInfo);
    setLoading(false);
  };

  const prepareActivityReport = async () => {
    let date = getFormattedDateWithHours(new Date());
    await prepareReportData();

    exportActivitiesToExcel(date + "_Intraday_Report_ACTIVITIES");
  };

  useEffect(() => {
    prepareReportData();
  }, [allFormsInAllPages]);

  useEffect(() => {
    checkAuthorization("INTRADAY_VIEW").then((result) => {
      if (result) {
        handleFetchFilteredProcesses();
        initialiseFilterItems();
        prepareReportData();
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  useEffect(() => {
    if (pageSize !== filter.size) {
      const updatedFilter = { ...filter, size: pageSize, page: 1 };
      setFilter(updatedFilter);
      setCurrentPage(1);

      // Use the updated filter directly for the API call
      api.getAllFilteredReports(updatedFilter).then(async (response) => {
        setNumberOfPages(response.data.object.totalPages);

        const { history } = response.data.object;

        const getUserPromises = history.map(async (process) => {
          let sumDurations = 0;
          if (process.allProcessTimes && process.allProcessTimes.length > 0) {
            process.allProcessTimes.forEach((time) => {
              sumDurations += time.duration;
            });
          }
          process.duration = sumDurations;

          if (process.userId !== null) {
            const user = await getUser(process.userId);
            process.agentName = user.name;
            process.acdLogin = user.username;
          }
          return process;
        });

        const updatedHistory = await Promise.all(getUserPromises);

        if (history.length === 0) {
          setHistoryForms([]);
        } else {
          setHistoryForms(
            updatedHistory.filter((process) => process.isFinalized)
          );
        }

        if (
          response.data.object.currentPage == 1 &&
          response.data.object.size == 0
        ) {
          setCurrentPage(0);
        }
        setNumberOfItems(response.data.object.totalSize);
      });
    }
  }, [pageSize]);

  return isLoading ? (
    <Loading></Loading>
  ) : (
    <div className="main-content-container">
      <div className="main-content">
        <div>
          <div className="main-content__title d-flex align-items-center justify-content-between">
            <h6 className="">{strings[pageTitle][language].pageTitle} </h6>
            <div className="d-flex align-items-end gap-2 ">
              <BootstrapButton
                variant="outline-primary"
                onClick={() => {
                  handleFetchFilteredProcesses();
                }}
              >
                {strings[pageTitle][language].refresh}
              </BootstrapButton>

              <BootstrapButton
                variant="outline-primary"
                onClick={() => {
                  prepareActivityReport();
                }}
              >
                {strings[pageTitle][language].exportActivities}
              </BootstrapButton>

              <BootstrapButton
                variant="outline-primary"
                onClick={() => {
                  let formsData = [];

                  historyForms.forEach((form) => {
                    //console.log(form);

                    let sumDurations = 0;
                    form.allProcessTimes.forEach((time) => {
                      sumDurations += time.duration;
                    });

                    sumDurations = secondsToHMS(sumDurations);

                    let formData = { ...exportDataModel };
                    formData["Activity Id"] = form.processId;
                    formData["Created"] = form.created;
                    formData["User Id"] = form.userId;

                    formData["Employee Name"] = form.agentName; //TODO: Find a way to map this agentId to a name

                    formData["ACD-Login"] = form.acdLogin;
                    let team = teams.find(
                      (team) => team.teamId === form.teamId
                    );

                    formData["Team"] = team.name;
                    formData["Service"] = form.service?.name;
                    formData["Form"] = form.form?.name;
                    formData["Activity Type"] = form.processType.name;
                    formData["Billable"] = form.isBillable ? "Yes" : "No";
                    formData["Start Time"] = form.allProcessTimes[0].startTime;
                    formData["End time"] =
                      form.allProcessTimes[
                        form.allProcessTimes.length - 1
                      ].endTime;
                    formData["Duration"] = sumDurations;
                    formData["Pause Duration"] = "TO BE DECIDED";
                    formData["Field Group"] = "-";
                    formData["Field Name"] = "-";
                    formData["Captured Value"] = "-";
                    formData["Unit"] = "-";

                    console.log(formData);

                    formsData.push(formData);
                    console.log(formsData);
                  });

                  let date = getFormattedDateWithHours(new Date());
                  console.log(date);
                  console.log(formsData);

                  generateReport(formsData, date + "_Intraday_Report");
                }}
              >
                {strings[pageTitle][language].export}
              </BootstrapButton>
            </div>
          </div>
          <hr className="main-content-title__hr" />

          {exportTableGPI.length > 0 && exportTableForms.length > 0 && (
            <table id="myTable" hidden={true}>
              <>
                <thead>
                  <tr>
                    <th colSpan={13}>{"General Process Information"}</th>
                    {exportTableForms.map((tableForm) => {
                      return (
                        <th
                          colSpan={tableForm[Object.keys(tableForm)[0]].length}
                        >
                          {Object.keys(tableForm)[0]}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{"Process Id"}</th>
                    <th>{"Start Time"}</th>
                    <th>{"End Time"}</th>
                    <th>{"Break"}</th>
                    <th>{"Process Time"}</th>
                    <th>{"Activity Type"}</th>
                    <th>{"Iposo Id"}</th>
                    <th>{"ACD Login"}</th>
                    <th>{"Employee"}</th>
                    <th>{"Team"}</th>
                    <th>{"Service"}</th>
                    <th>{"Billable"}</th>
                    <th>{"Form Name"}</th>
                    {exportTableForms.map((tableForm) => {
                      //console.log(tableForm);
                      let tableForms = tableForm[Object.keys(tableForm)[0]];
                      if (tableForms.length === 0) {
                        tableForms = ["-"];
                      }

                      return tableForms.map((item) => {
                        let extractedArr = Object.values(item)[0];
                        if (extractedArr == "") {
                          extractedArr = "-";
                        }
                        return <th>{extractedArr}</th>; //tableForm[Object.keys(tableForm)[0]]
                      });
                    })}
                  </tr>

                  {exportTableGPI &&
                    allProcessFieldsInfo &&
                    exportTableGPI.map((row, rowIndex) => {
                      return (
                        <tr>
                          <td>{row["Activity Id"]}</td>
                          <td>{row["Start Time"]}</td>
                          <td>{row["End time"]}</td>
                          <td>{row["Pause Duration"]}</td>
                          <td>{row["Duration"]}</td>
                          <td>{row["Activity Type"]}</td>
                          <td>{"???"}</td>
                          <td>{row["ACD-Login"]}</td>
                          <td>{row["Employee Name"]}</td>
                          <td>{row["Team"]}</td>
                          <td>{row["Service"]}</td>
                          <td>{row["Billable"]}</td>
                          <td>{row["Form"]?.name}</td>
                          {allProcessFieldsInfo[rowIndex]?.map((field) => {
                            return <td>{field}</td>;
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </>
            </table>
          )}

          <div className="ms-2 mt-2 d-flex gap-1 max-width-800 mx-auto p-3  flex-wrap">
            <h6 className="grid-item-title" style={{ whiteSpace: "nowrap" }}>
              {strings[pageTitle][language].filterBy}{" "}
            </h6>
            <DropdownSearch
              items={activityTypes}
              label="Activity Type"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[0]}
            ></DropdownSearch>
            <DropdownSearch
              items={services}
              label="Services"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[1]}
            ></DropdownSearch>
            <DropdownSearch
              items={forms}
              label="Forms"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[2]}
            ></DropdownSearch>
            <DropdownSearch
              items={users}
              label="Users"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[3]}
            ></DropdownSearch>
            <DropdownSearch
              items={teams}
              label="Teams"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[4]}
            ></DropdownSearch>
            <DropdownSearchSingle
              items={billableTypes}
              label="Billable"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[5]}
            ></DropdownSearchSingle>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <table
                style={{ boxSizing: "content-box", margin: "2em" }}
                className="activity-table"
              >
                <thead>
                  <tr>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[0]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[1]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[2]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[3]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[4]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[5]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[6]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[7]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[8]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[9]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[10]}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {historyForms &&
                    historyForms.map((process, index) => (
                      <tr key={index}>
                        <td>{process.processType?.name}</td>
                        <td>{process.service?.name}</td>
                        <td>{process.form?.name}</td>
                        <td>
                          {teams.find((t) => t.teamId == process.teamId)
                            ?.name || process?.teamId}
                        </td>
                        <td>{process?.agentName}</td>
                        <td>{process?.userId}</td>
                        <td>{process?.acdLogin}</td>
                        <td>{process?.isBillable ? "True" : "False"}</td>
                        <td>{timestampToHHMMSS(process?.created)}</td>
                        <td>
                          {timestampToHHMMSS(
                            process?.allProcessTimes[
                              process.allProcessTimes.length - 1
                            ].endTime
                          )}
                        </td>
                        <td>{secondsToHMS(process.duration)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <div
                style={{ borderBottom: "1px solid black", margin: "1em" }}
              ></div>
              <nav className="pagination-container">
                <div
                  style={{
                    minWidth: "100px",
                    marginRight: "1em",
                    position: "absolute",
                    right: "0",
                  }}
                >
                  <Select
                    options={pageSizeOptions}
                    value={pageSizeOptions.find(
                      (opt) => opt.value === pageSize
                    )}
                    onChange={(selectedOption) =>
                      setPageSize(selectedOption.value)
                    }
                    isSearchable={false}
                  />
                </div>
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: 1 });
                        setCurrentPage(1);
                        handleFetchFilteredProcesses("", 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <FirstPageIcon></FirstPageIcon>{" "}
                      {strings[pageTitle][language].first}
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage - 1 });

                        setCurrentPage(currentPage - 1);
                        handleFetchFilteredProcesses("", currentPage - 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <ArrowBackIosIcon></ArrowBackIosIcon>{" "}
                      {strings[pageTitle][language].previous}
                    </Button>
                  </li>
                </ul>

                <p>
                  {strings[pageTitle][language].page} {currentPage}{" "}
                  {strings[pageTitle][language].of} {numberOfPages} (
                  {numberOfItems} {strings[pageTitle][language].items})
                </p>
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage + 1 });

                        setCurrentPage(currentPage + 1);
                        handleFetchFilteredProcesses("", currentPage + 1);
                      }}
                      disabled={currentPage === numberOfPages}
                    >
                      {strings[pageTitle][language].next}{" "}
                      <ArrowForwardIosIcon></ArrowForwardIosIcon>
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        console.log(numberOfPages);

                        setCurrentPage(numberOfPages);
                        handleFetchFilteredProcesses("", numberOfPages);
                      }}
                      disabled={currentPage == numberOfPages}
                    >
                      {strings[pageTitle][language].last}
                      <LastPageIcon></LastPageIcon>
                    </Button>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminIntradayView;
